<template>
  <layout-blank>
    <slot></slot>
  </layout-blank>
</template>

<script>
// eslint-disable-next-line import/extensions
import LayoutBlank from '@/@core/layouts/variants/blank/LayoutBlank.vue'

export default {
  components: {
    LayoutBlank,
  },
}
</script>

<style>
</style>
